import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Loader2, ShoppingCart } from "lucide-react";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";

export function BuyNumber({ bid, onDone }) {
  const [ok, setOk] = useState(false), [busy, setBusy] = useState(false);
  const { data: q } = useQuery({ queryKey: ["shally-quote", bid], queryFn: async () => (await api.get(`/receptionist/setup/${bid}/number-quote`)).data });
  const buy = async () => {
    setBusy(true);
    try { await api.post(`/receptionist/setup/${bid}/buy-number`, { confirm: true }); toast.success("Your Shally number is ready. Calls stay off until you activate Shally."); }
    catch (e) { toast.error(apiErr(e)); setOk(false); } finally { setBusy(false); onDone(); }
  };
  return (
    <div className="mt-5 rounded-xl border border-primary/30 bg-primary/5 p-4" data-testid="onb-buy">
      <p className="font-semibold text-slate-900 dark:text-white">Get your Shally number</p>
      <p className="mt-1 text-sm text-slate-600 dark:text-slate-300" data-testid="onb-buy-price">{q?.label || "Loading price…"}</p>
      <p className="mt-1 text-xs text-slate-500 dark:text-slate-400">Pawkt buys one Indian number for this branch. Your business number forwards to it.</p>
      <label className="mt-3 flex items-start gap-2 text-sm text-slate-700 dark:text-slate-200">
        <input type="checkbox" className="mt-1 h-4 w-4" checked={ok} onChange={(e) => setOk(e.target.checked)} data-testid="onb-buy-confirm" />
        I confirm Pawkt may buy a Shally number for this branch (about ₹{q?.approx_inr_per_month ?? 210}/month, included in my plan).
      </label>
      <Button className="mt-3 h-11 rounded-xl" disabled={!ok || busy} onClick={buy} data-testid="onb-buy-btn">
        {busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <ShoppingCart className="mr-2 h-4 w-4" />}Buy a Shally Number</Button>
    </div>);
}
